import { store } from '../redux/store';
import { displayError, displayErrorString, handleUnauthorized} from '../api-utilities/api-calls';
import { getAuthToken } from './projectDataService';
import { IUserInfo } from '../interfaces/interfaces';
import { getStringId } from '../api-utilities/formatting';
//This file contains calls to the Lowry backend, which gets results from the PricingDataAPI

const apibase = process.env.REACT_APP_CLIENT_API;

export async function getPriceAndRecalcLevel(projectId: any, unitId: any){
  const token = await getAuthToken();
  let projIdStr = getStringId('project', projectId);
  let unitIdStr = getStringId('unit', unitId);

  const result = await fetch(apibase + `/dataapi/getPriceAndRecalcLevel/${projIdStr}/${unitIdStr}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  handleUnauthorized(result.status, 'getPriceAndRecalcLevel');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}
export async function updateMultipleUnitPricing(projectId:any, unitIds:string[]){
  const auth = store.getState().reduxAuth;
  const projectManagment = store.getState().reduxProjectManagement;
  const token = await getAuthToken();

  let projIdStr = getStringId('project', projectId);

  const graphMultipleUnitPricingRequest = {
    projectId: projIdStr,
    unitIds: unitIds,
    saveToDatabase: true
    };

    try {
      const result = await fetch(apibase + '/dataapi/updateMultipleGraphUnitPrice', {
        method: 'post',
        body: JSON.stringify(graphMultipleUnitPricingRequest),
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
      });
      if (result.status === 200) {
        return await result.json();
      }
    } catch (error) {
      let err = {
          hasError: true, errorMessage: error
      }
    return err;
    }  
}
export async function updateUnitPrice(projectId: any, unitId: any) {
  const auth = store.getState().reduxAuth;
  const projectManagment = store.getState().reduxProjectManagement;
  const token = await getAuthToken();
  let projIdStr = getStringId('project', projectId);
  let unitIdStr = getStringId('unit', unitId);

  const graphUnitPricingRequest = {
    projectId: projIdStr,
    unitId: unitIdStr,
    saveToDatabase: true
    };

  try {
    const result = await fetch(apibase + '/dataapi/updateGraphUnitPrice', {
      method: 'post',
      body: JSON.stringify(graphUnitPricingRequest),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    });
    if (result.status === 200) {
      return await result.json();
    }
    else{
        let error = {
            hasError: true, errorMessage: "Request failed"
        }
      return error;
    }
  } catch (error) {
    let err = {
        hasError: true, errorMessage: error
    }
  return err;
  }
}


export async function generateUnitPriceSummary(projectId:any, unitId:any, ){
  const apibase = process.env.REACT_APP_CLIENT_API;
  const token = await getAuthToken();
  let response;

  const unitPriceRequest = {
      projectId: projectId,
      unitId: unitId,
      saveToDatabase: true
      };
  
      const result = await fetch(apibase + '/dataapi/generateUnitPriceSummary', {
          method: 'post',
          body: JSON.stringify(unitPriceRequest),
          headers: { 'Content-Type': 'application/json',
              Authorization: `Bearer ${token}` }
      });
      response = {
        //Handles the call from pdf Service
        success: result.status === 200 ? true:false,
        data: result.status === 200 ? await result.json() : await result.text()
      };
      //If not success then display error.
      if(!response.success){
        let errorObj = {
            status: result.status,
            message: response.data.errorMessage
        }
        displayError(errorObj, "GenerateUnitPriceSummary");
        return;
    }
    return response;
}